export default __webpack_public_path__ + "static/media/change_person.4f4ff550.png";